// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navigation-child-wrapper {
  padding-left: 15px;
}

.readonly-item:hover {
  text-decoration: none;
}`, "",{"version":3,"sources":["webpack://./src/main/webapp/app/shared/layout/main-sidebar/main-sidebar-wrapper.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;;AAEA;EACE,qBAAA;AACF","sourcesContent":[".navigation-child-wrapper {\n  padding-left: 15px;\n}\n\n.readonly-item:hover {\n  text-decoration: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
